<template>
  <v-navigation-drawer
    app
    width="280"
    color="red"
    v-model="drawer"
    :right="$vuetify.rtl"
    :mini-variant="ismini"
    @mouseleave.native="mini = true"
    @mouseover.native="mini = false"
  >
    <v-toolbar flat class="app-toolbar shadow-md" dark color="primary">
      <v-list class="primary">
        <v-list-tile class="primary">
          <v-list-tile-avatar size="54">
            <v-icon large color="white">mdi-clipboard-check</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content class="pt-2">
            <v-list-tile-title
              class="title pb-0 mb-0 subheading font-weight-medium"
              >{{ $t("APP_NAME") }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-spacer />
      <v-btn
        icon
        flat
        class="ma-0"
        @click.stop="clipped = !clipped"
        v-if="$vuetify.breakpoint.width > 1263"
      >
        <v-icon size="22" color="white">{{
          clipped ? "radio_button_checked" : "radio_button_unchecked"
        }}</v-icon>
      </v-btn>
      <v-icon
        v-else
        @click="drawer = false"
        :class="$vuetify.rtl ? 'ml-2' : 'mr-2'"
      >
        arrow_back
      </v-icon>
    </v-toolbar>
    <v-divider />
    <v-list>
      <v-list-tile class="mt-0 py-3">
        <v-list-tile-avatar size="46">
          <img :src="user.image" alt="alt" class="user-image" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t("APP_NAME") }}</v-list-tile-title>
          <v-list-tile-sub-title
            >{{ user.name }} - {{ roles }}</v-list-tile-sub-title
          >
        </v-list-tile-content>
      </v-list-tile>
      <template v-for="(item, i) in items">
        <v-layout v-if="item.heading" align-center :key="i">
          <v-subheader class="f_12" v-text="item.heading" />
          <v-divider />
        </v-layout>
        <v-list-group
          no-action
          :key="'c' + i"
          v-model="item.model"
          v-else-if="item.children"
          active-class="secondary--text"
          :prepend-icon="item.group_icon"
        >
          <v-list-tile
            slot="activator"
            active-class="secondary--text nav-active"
          >
            <v-list-tile-content>
              <v-list-tile-title class="IR_M f_12">
                {{ $t(item.title) }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            exact
            :key="i"
            :to="child.path"
            v-for="(child, i) in item.children"
            active-class="secondary--text nav-active"
          >
            <v-list-tile-action>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="f_12">
                {{ $t(child.title) }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-list-tile
          v-else
          exact
          :key="'d' + i"
          :to="item.path"
          active-class="secondary--text nav-active"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="f_12">
              {{ $t(item.title) }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: ["appDrawer"],
  data: () => ({
    clipped: true,
    mini: false
  }),

  computed: {
    ismini: ({ mini, clipped }) => mini && !clipped,

    drawer: {
      get: ({ appDrawer }) => appDrawer,
      set(val) {
        this.$emit("update:appDrawer", val);
      }
    },
    items() {
      return this.$store.getters.getSidebarLinks;
    },
    user() {
      return this.$store.getters["AuthModule/current_user"]["user"];
    },
    roles() {
      let result = "";
      this.user.roles.forEach(element => {
        result += " " + element.name;
      });
      return result;
    }
  }
};
</script>
<style>
.app-toolbar .v-toolbar__content {
  padding: 0px;
  padding-left: 12px;
}
</style>
